import {Component, Input} from '@angular/core';
import {
  EventClassResponse,
  EventResponse,
  EventServiceResponse
} from '../../../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  _AQH_EVE_10,
  _AQH_EVE_13, _AQH_EVE_14,
  _AQH_EVE_9,
  AQH_EVE_11,
  AQH_EVE_6
} from '../../../../../../../../@shared/models/input.module';
import {EVENT_CLASS_STATUSES, formatTimeDMYHHMM} from '../../../../../../../../@core/utils/utils.service';
import {AddEventService} from './components/add-event-service/add-event-service';
import {EditEventService} from './components/edit-event-service/edit-event-service';
import {DeleteModal} from '../../../../../../../../@shared/components/delete-modal/delete-modal';
import {ViewServiceRegistrations} from './components/view-service-registrations/view-service-registrations';


@Component({
  selector: 'app-manage-event-service',
  standalone: false,
  templateUrl: './manage-event-service.html',
  styleUrl: './manage-event-service.css'
})
export class ManageEventService {
  @Input() event: EventResponse
  eventServices: EventServiceResponse[]

  constructor(private eventService: EventsService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getEventServices()
  }

  getEventServices() {
    let params: AQH_EVE_11 = {
      event_id: this.event.event_id
    }
    this.eventService.getEventServices(params).subscribe((data) => {
      this.eventServices = data
      console.log("Event Services: ", data);
    });
  }

  openAddEventServiceModal() {
    let modalRef = this.modalService.open(AddEventService, {centered: true, size: 'lg'});
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result) => {
      if (result) {
        this.getEventServices()
      }
    }).catch((error) => {
      // Handle dismissal if needed
    });
  }


  openEditEventServiceModal(service: EventServiceResponse) {
    let modalRef = this.modalService.open(EditEventService, {centered: true, size: 'lg'});
    modalRef.componentInstance.service = service;
    modalRef.result.then((result) => {
      if (result) {
        this.getEventServices()
      }
    })
  }

  openViewRegistrationsModal(service: EventServiceResponse) {
    let modalRef = this.modalService.open(ViewServiceRegistrations, { size: 'xl', centered: true });
    modalRef.componentInstance.eventService = service;

    modalRef.result.then((updated) => {
      if (updated) {
        // Refresh the event services list to show updated data
        this.getEventServices();
      }
    }, () => {
      // Modal dismissed without changes
    });
  }

  deleteEventService(service: EventServiceResponse) {
    let modalRef = this.modalService.open(DeleteModal, {centered: true, size: 'lg'});
    modalRef.componentInstance.description = 'Are you sure you want to delete the event service "' + service.event_service_name + '"? This action cannot be undone.';
    modalRef.result.then((res) => {
      if (res) {
        let params: _AQH_EVE_14 = {
          event_service_id: service.event_service_id
        }
        this.eventService.deleteEventService(params).subscribe((data) => {
          this.getEventServices()
        });
      }
    })
  }

  getTotalRegistrations(service: EventServiceResponse): number {
    if (!service.event_service_registrations || service.event_service_registrations.length === 0) {
      return 0;
    }
    return service.event_service_registrations.reduce((total, registration) => {
      return total + (registration.num_registrations || 0);
    }, 0);
  }

  protected readonly formatTimeDMYHHMM = formatTimeDMYHHMM;
  protected readonly EVENT_CLASS_STATUSES = EVENT_CLASS_STATUSES;
}
